<template>
  <div
    class="card position-relative shadow"
    style="height:246px;width:246px"
  >
    <div
      v-if="isEditable"
      class="position-absolute cursor-pointer"
      style="right:16px; top: 16px; z-index:100"
      @click="edit"
    >
      <v-icon icon="pen" />
    </div>
    <div
      class="card-body rounded-4 transition-shadow position-relative"
      :class="`box-shadow-${color}-300 box-shadow-hover-${color}-300`"
    >
      <span
        v-for="i in 3"
        :key="i"
        class="pills-image"
        :class="[ `pill-card-${index}-${i}` ]"
      />

      <div
        class="position-relative d-flex flex-column"
        style="z-index:30;height:216px;"
      >
        <div class="d-flex mt-3 mx-auto lead fw-bold text-gray-600">
          <slot name="title" />
        </div>
        <div class="d-flex flex-column m-auto text-center h5">
          <slot name="content" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: [String, null],
      default: null,
    },
    pillsType: {
      type: Number,
      default: 0,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    modalComponent: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      animate: 'animate__animated animate__shakeY animate__infinite',
    };
  },
  computed: {
    index() {
      return [
        'blue',
        'yellow',
        'pink',
        'green',
      ].indexOf(this.color) + 1;
    },
  },
  methods: {
    edit() {
      this.$emit('edit', this.modalComponent);
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 1400px ) {

}
@media screen and (min-width: 1200px ) {

}
.pills-image {
  height: 12px;
  border-radius: 60px;
  position: absolute;
  z-index: 3;
}

.pill-card-1-1 {
  left: 20px;
  width: 39px;
  top: 35%;
  background-color: var(--bs-yellow-500);
}
.pill-card-1-2 {
  left: 30px;
  width: 64px;
  bottom: 10%;
  background-color: var(--bs-green-500);
}
.pill-card-1-3 {
  bottom: 14%;
  width: 48px;
  right: 30px;
  background-color: var(--bs-pink-500);
}

.pill-card-2-1 {
  top: 37%;
  right: 20px;
  width: 48px;
  background-color: var(--bs-blue-500);
}
.pill-card-2-2 {
  left: 30px;
  width: 50px;
  height: 10px;
  bottom: 20%;
  background-color: var(--bs-green-500);
}
.pill-card-2-3 {
  bottom: 10%;
  width: 33px;
  right: 30px;
  background-color: var(--bs-pink-500);
}

.pill-card-3-1 {
  top: 30%;
  width: 39px;
  height: 8px;
  right: 30px;
  background-color: var(--bs-yellow-500);
}
.pill-card-3-2 {
  bottom: 17%;
  width: 30px;
  right: 30px;
  background-color: var(--bs-green-500);
}
.pill-card-3-3 {
  bottom: 20%;
  width: 32px;
  left: 40px;
  background-color: var(--bs-blue-500);
}

.pill-card-4-1 {
  top: 35%;
  width: 32px;
  left: 20px;
  background-color: var(--bs-blue-500);
}
.pill-card-4-2 {
  bottom: 20%;
  width: 32px;
  left: 40px;
  background-color: var(--bs-yellow-500);
}
.pill-card-4-3 {
  bottom: 13%;
  width: 48px;
  right: 30px;
  background-color: var(--bs-pink-500);
}
</style>
